module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/190/assets/images/19818a114e5605dd90e12504b0d14849.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_pencil_hover.svg
// module id = jU6I
// module chunks = 1